module.exports = __webpack_public_path__ + "static/media/user-avatar.5df93af0.jpg";